import { render, staticRenderFns } from "./FormatDateActionFields.vue?vue&type=template&id=04e7803f"
import script from "./FormatDateActionFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormatDateActionFields.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports